var map = {
	".": 57154,
	"./": 57154,
	"./assets/img/builde_ai.png": 36951,
	"./assets/img/logo/builde-logo-gradient.png": 37887,
	"./assets/img/logo/instagram-logo-transparent.png": 85822,
	"./assets/img/logo/instagram-logo.png": 51752,
	"./assets/img/logo/youtube-logo.png": 29071,
	"./assets/index.css": 32719,
	"./contact": 63486,
	"./contact.jsx": 63486,
	"./data": 20314,
	"./data.json": 20314,
	"./footer": 12513,
	"./footer.jsx": 12513,
	"./header": 41335,
	"./header.jsx": 41335,
	"./index": 57154,
	"./index.js": 57154,
	"./join": 56071,
	"./join.jsx": 56071
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68317;